import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * コメント
 */
export class Comment extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): Comment {
    return new Comment(value);
  }
}
